const NotificationMessage = Object.freeze({
    sessionSavingError : "Failed to save session to the cookie storage. ",
    roleNameAlreadyRecorded : "Role already recorded.",
    mustSelectOne: "You Must select One ",
    mustSelectAtLeastOne : "You Must select at least one ",
    AreYouSureYouWantToDelete : "Are you sure you want to delete the selected ",
    DeletionInProgress : "Deletion in progress...",
    YouMustSelectARole : "You Must select a Role from the dropdown list",
    MustAnswerAllQuestions : "You must answer all questions before proceeding",
    YouMustSelectAChoice : "You Must select a Choice.",
    ReviewAnswers:"Please review your responses. There are pending questions unanswered."
});


export default NotificationMessage;